import React, { useLayoutEffect } from 'react';

import { GenericAsyncSelect } from 'src/views/components/select';

const SelectWhenHaveOptions = ({ useOptions, value, onChange, name, ...props }) => {
  const options = useOptions() || [];
  let hasExactOne = options && options.length === 1;
  useLayoutEffect(() => {
    if (value && hasExactOne) {
      onChange({ target: { name, value: null } });
    }
  }, [name, value, hasExactOne, onChange]);

  return (
    <GenericAsyncSelect
      isDisabled={hasExactOne}
      className="select-when-have-options"
      value={value || options[0] || null}
      onChange={onChange}
      name={name}
      options={options}
      {...props}
    />
  );
};

export default SelectWhenHaveOptions;
